"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type FaqItem = {
  question: string;
  answer: string;
};

const defaultFaqs: FaqItem[] = [
  {
    question: "How do I place a bid on a property?",
    answer:
      "To place a bid, navigate to the property listing and click the 'Place a bid' button. Enter your offer amount and any additional information you'd like to include with your bid.",
  },
  {
    question: "What happens if my bid is accepted?",
    answer:
      "If your bid is accepted, you'll receive a notification and can proceed with the rental application process. The landlord will contact you to discuss next steps.",
  },
  {
    question: "How do I save a property to my favorites?",
    answer:
      "Click the heart icon on any property listing to save it to your favorites. You can view all saved properties in the 'Saved Listings' section.",
  },
  {
    question: "Can I message landlords directly?",
    answer:
      "Yes! You can send messages to landlords through the property listing page.",
  },
  {
    question: "What information do I need for my profile?",
    answer:
      "We recommend completing your profile with your contact information, rental history, income details, and any preferences to help landlords make informed decisions.",
  },
  {
    question: "How do I update my search preferences?",
    answer:
      "Go to your profile settings and update your search criteria including location, price range, number of bedrooms, and other preferences.",
  },
];

export default function FaqModal({
  open,
  onOpenChange,
  faqs = defaultFaqs,
}: {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  faqs?: FaqItem[];
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            Frequently Asked Questions
          </DialogTitle>
        </DialogHeader>

        <Accordion type="single" collapsible className="mt-2 w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger>{faq.question}</AccordionTrigger>
              <AccordionContent>{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </DialogContent>
    </Dialog>
  );
}
